import { downgradeComponent } from "@angular/upgrade/static";
import { AiActivitiesPageComponent } from './ai-activities-page.component';

export const AiActivitiesPageAjsModule = angular
  .module('aiActivitiesPage', [])
  .directive('aiActivitiesPage', downgradeComponent({ component: AiActivitiesPageComponent }))
  .config(
    ['$stateProvider', ($stateProvider) => {
      $stateProvider.state('missioncontrol.aiActivities', {
        url: '/aiActivities',
        component: AiActivitiesPageComponent,
        data: {
          requireLogin: true
        }
      });
    }
    ])
  .name;
